var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion" },
    [
      _c(
        "button",
        { staticClass: "accordion__btn", on: { click: _vm.toggle } },
        [
          _vm._t("title"),
          _vm._v(" "),
          _c("span", { staticClass: "direction no_print" }, [
            _vm._v(_vm._s(_vm.directionMessage[_vm.direction]) + " "),
            _c("i", { class: "uk-icon-chevron-" + _vm.direction }),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "animate-wrapper",
        {
          attrs: {
            isVisible: _vm.direction === "up",
            targetHeight: _vm.contentHeight,
          },
        },
        [
          _c(
            "div",
            { ref: "contentWrapper", staticClass: "accordion__content" },
            [_vm._t("content")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }